import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85711bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "onboarding" }
const _hoisted_2 = { class: "get-start-section" }
const _hoisted_3 = { class: "container top" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "container get-start-section__container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MarketingContent = _resolveComponent("MarketingContent")!
  const _component_SubmissionForm = _resolveComponent("SubmissionForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require(`../assets/torq-logo.svg`),
          style: {"width":"10vw","display":"flex"},
          alt: "logo"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_MarketingContent),
        _createVNode(_component_SubmissionForm, {
          "submission-url": this.submissionUrl
        }, null, 8, ["submission-url"])
      ])
    ])
  ]))
}